module.exports = __webpack_public_path__ + "static/media/design.e42a77a6.svg";